export default {
    namespaced: true,
    state: {
        list: [
            {
                label: 'Не оплачен',
                value: 0,
            },
            {
                label: 'Частично оплачен',
                value: 1,
            },
            {
                label: 'Полностью оплачен',
                value: 2,
            },
            {
                label: 'Переплата',
                value: 3,
            },
        ],
        load: false,
    },
    actions:{
        get_list(){},
    },
    getters: {
        list: (state, getters, rootState, rootGetters) => {
            return state.list;
        },
    }
}